<template>
    <div class="card-wrapper">
        <v-card class="ma-2 elevation-3">
            <div class="offset-header">
                <v-card color="primary" class="header-card border-r-5 card-header">
                    <v-card-title class="headline">
                        <v-layout row justify-space-between>
                            <v-flex md1 v-if="!!icon">
                                <v-icon color="white" v-if="!!icon" x-large class="material-icons">
                                    {{ icon }}
                                </v-icon>
                            </v-flex>
                            <v-flex md11 class="ma-2">
                                {{ blockTitle }}
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                </v-card>
            </div>
            <v-card-text>
                <slot name="block-elements"></slot>
            </v-card-text>
            <v-card-actions>
                <slot name="actions"></slot>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
export default {

    props: {
        blockTitle: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            default: undefined,
        },
    },
};
</script>

<style scoped>
.card-wrapper {
    margin-top: 30px;
    background-color: white;
}
    .offset-header {
        top: -30px !important;
        margin: 0 auto;
        max-width: calc(100% - 32px);
    }
    .border-r-5 {
       /* border-radius: 5px;*/
    }
    .header-card {
        top: -30px !important;
        margin: 0 auto;
        max-width: calc(100% - 32px);
        min-height: 20px;
        color: white;
        /*font-weight: bold;*/
        font-size: 16px;
    }
    .card-header{
        transition: all ease-in-out 0.3s;
    }

    .headline {
        font-weight: 200 !important;
        font-size: 16px !important;
    }

    .v-card__title {
        padding: 5px !important;
    }

</style>
